/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/*@ngInject*/
export default function LoginController(utils, loginService, keycloakService, userService) {
    var vm = this;

    vm.$onInit = function () {
        vm.user = {
            name: '',
            password: ''
        };

        vm.login = login;
        // eslint-disable-next-line
        vm.oAuthLogin = oAuthLogin;

        vm.ssoLoginMessage = utils.getCustomizedMessage('ssoLoginButton') || 'login.oauth-login';
        vm.keycloakEnabled = window.DynamicConfigs.keycloakEnabled === 'true';// eslint-disable-line
        console.log("login keyloakEnabled == " + vm.keycloakEnabled);// eslint-disable-line
    };

    function doLogin() {
        loginService.login(vm.user).then(function success(response) {
            var token = response.data.token;
            var refreshToken = response.data.refreshToken;
            userService.setUserFromJwtToken(token, refreshToken, true);
        }, function fail() {
        });
    }

    function login() {
        doLogin();
    }

    function oAuthLogin() {
        keycloakService.login();
    }
}



// WEBPACK FOOTER //
// ./src/app/login/login.controller.js